exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".slide-enter-active,.slide-leave-active{transition:all .3s ease}.slide-enter,.slide-leave-to{opacity:0;transform:translateY(-20%)}", ""]);

// exports
